import { render, staticRenderFns } from "./ListFileComponent.vue?vue&type=template&id=11480a23"
import script from "./ListFileComponent.vue?vue&type=script&lang=js"
export * from "./ListFileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports